import React from 'react';
import { Modal, ModalProvider } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import GravityFormSubmitResultNotice from './GravityFormSubmitResultNotice';
const GravityFormSubmitResultModal = (props) => {
    const { gravityFormStore, hasError, modalContent } = props;
    const handleResultModalClose = () => {
        gravityFormStore.toggleFormSubmitResultModal(false);
    };
    return (React.createElement(ModalProvider, { isClosable: true, isOpen: gravityFormStore.isFormSubmitResultModalOpen, onToggle: (isOpen) => !isOpen && handleResultModalClose() },
        React.createElement(Modal, { size: "6-col" },
            React.createElement(GravityFormSubmitResultNotice, { hasError: hasError, modalContent: modalContent }))));
};
export default inject('gravityFormStore')(observer(GravityFormSubmitResultModal));
//# sourceMappingURL=GravityFormSubmitResultModal.js.map